













import { Vue, Component, Prop } from 'vue-property-decorator';
import { List } from 'vant';
import NewsItem from '@/components/next/NewsItem.vue';
import { fetchNewslist } from '@/api/api';
Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class NewsList extends Vue {
  @Prop() voteName!: string;
  @Prop({ default: '资讯' }) title!: string;
  @Prop() classId!: number;
  loading = false;
  finished = false;
  page = 1;
  getNewsList: any[] = [];
  loadingStatus = true;

  onLoad() {
    if (this.loadingStatus) {
      this.loadingStatus = false;
      setTimeout(() => {
        fetchNewslist(this.page, this.classId).then((res) =>
          this.endNewsData(res),
        );
      }, 150);
    }
  }
  endNewsData(res: any) {
    if (!res.data) {
      this.finished = true;
    } else {
      this.getNewsList = [...this.getNewsList, ...res.data];
      this.page = this.page + 1;
    }
    this.loading = false;
    this.loadingStatus = true;
  }

  onJumpToDetail(newsItem: any) {
    if (window.udid && newsItem.dataType !== 7 && newsItem.dataType !== 5) {
      const { id, classId, dataType } = newsItem;
      const option = {
        dt: dataType,
        cid: classId,
        nid: id,
      };
      window.handleMessage(
        JSON.stringify({
          action: 'mJump',
          data: JSON.stringify(option),
        }),
      );
    } else {
      location.href = newsItem.targetUrl;
    }
  }
}
